module.exports = __webpack_public_path__ + "static/itsm_capabilities_3_6-2ec36adfe89a8d0d0e44aaf8eec0a947.png";